import Backbone from 'backbone'
import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'
import $ from 'jquery'
import appDisplay from 'scoreboard/components/app-display'
import escapePreserveLineBreaks from 'scoreboard/components/escape-preserve-line-breaks'
import formatValue from 'scoreboard/components/format-value'
import highlight from 'scoreboard/components/highlight'
import metadata from 'scoreboard/components/metadata'
import sections from 'scoreboard/components/sections'
import alertMetadata from 'scoreboard/alerts/alert-metadata'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import template from './alert-list.hbs'
import alertTemplate from './alert.hbs'
import Alert from 'scoreboard/alerts/alert'
import periodChangeConfirmation from './period-change-confirmation'
import Xhr from 'scoreboard/components/xhr'
import LineClamp from 'scoreboard/components/line-clamp'
import user from 'scoreboard/components/user'
import ExportStatusDialog from 'scoreboard/components/export/export-status-dialog'
import conductor from 'scoreboard/components/conductor'
import calendars from 'scoreboard/components/calendars'
import DataType from 'scoreboard/datasets/model/data-type'
const { NUMBER } = DataType
import alertDomainPeriodsTemplate from './alert-domain-periods.hbs'
import alertMetricValuesReviewedTemplate from './alert-metric-values-reviewed.hbs'

/**
 * @returns {boolean} true if the alerts messenger implements
 *     PeriodGroupMessenger, indicating that the content is structured in a
 *     period/org/node hierarchical grouping
 */
const isPeriodGroup = (alert) => {
	return !_.isNil(_.get(alert, 'context.periods[0].orgs[0].nodes'))
}

const isOfType = (alert, types) => {
	const type = _.get(alert, 'type')
	return _.includes(types, type)
}

var AlertList = Backbone.View.extend({

	tagName: 'ul',

	className: 'alert-list list list-striped list-with-actions list-with-details',

	/**
	 * @param {Object} data The alert data
	 */
	initialize: function(options = {}) {
		this.options = options
		this.alertList = this.alerts()
		this.alertClamps = []
		_.bindAll(this, 'adjustOverflow')
	},

	events: {
		'click .alert-item:not(.is-not-clickable)': 'goToAlert',
		'click .mark-as-read' : 'onRead',
		'click .mark-as-unread' : 'onUnread',
		'click .delete' : 'onDelete'
	},

	render: function() {
		this.$el.html(template(this.alertList))
		// Wait till the list items are in the DOM to adjust them
		process.nextTick(function() {
			this.adjustOverflow()
		}.bind(this))

		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })

		$(window).on('resize', this.adjustOverflow)

		// Setup already rendered alerts from this.options.data
		this._setupLineClamps()

		return this
	},

	_setupLineClampForAlert: function(el, id) {
		var clamp = new LineClamp({ el, maxHeight: 135 })
		clamp.resize()
		this.alertClamps.push({ id, clamp })
	},

	_setupLineClamps: function(newAlert) {
		if (newAlert) {
			let el = this.$(`[data-id=${newAlert.id}] .alert-clamp-container`)
			let id = newAlert.id
			this._setupLineClampForAlert(el, id)
		} else {
			_.map(this.$('li.alert-item'), alert => {
				let el = this.$(alert).find('.alert-clamp-container')
				let id = this.$(alert).data('id')
				this._setupLineClampForAlert(el, id)
			})
		}
	},

	/**
	 * Renders a new alert at the bottom of the list
	 */
	appendAt: function(index, alert) {
		const newAlertHtml = template([this.createAlertContext(alert)])
		if (index <= 0) {
			this.$el.prepend(newAlertHtml)
		} else {
			const attachAfter = this.$el.find(`li.alert-item`).get(index-1)
			if (attachAfter) {
				$(newAlertHtml).insertAfter(attachAfter)
			} else {
				this.$el.append(newAlertHtml)
			}
		}

		// line clamp the newly created alert
		this._setupLineClamps(alert)
	},

	disableAlertActions: function() {
		this.$('.button-covert').hide()
	},

	// Adjust the height of the alertlist items if they're over the max height allowed
	adjustOverflow: function() {
		_.map(this.alertClamps, c => c.clamp.resize())
	},

	/**
	 * @param {Object<Object<Number>>} alertsDataById
	 * 		alertsDataById {domainType: [{domainId: domainObject}]}
	 * 		see alertHelper.dataByIdByDomainType
	 */
	alerts: function() {
		return _.map(this.options.data.alerts, alert => {
			return this.createAlertContext(alert)
		})
	},

	createAlertContext: function(alert) {
		const alertsData = this.options.data
		let {domainId, domainType, focusNodeIds} = alert
		domainId = _.defaultTo(domainId, _.first(focusNodeIds))

		const domainItems = domainType && alertsData[domainType]
		const domainItem = domainItems && domainItems[domainId]
		var section = domainType && metadata[domainType].section

		const setTitleFromDomainObject = () => {
			const organization = domainItem && alertsData.organizations[domainItem.organizationId]
			context.title = this._resolveTitle(alert, domainItem)
			context.subTitle = organization && _.result(organization, 'label',
				i18n.get('alerts.deletedDomainObjectOrganization'))
		}

		const alertModel = new Alert(alert)
		const context = {alert, domainItem, section}
		context.message = alertModel.getMessage()
		context.read = alert.read
		const isMetricValuesReviewed = isOfType(alert, ['metric-values-reviewed'])
		if (isMetricValuesReviewed) {
			context.detail = this._getMetricValuesReviewedTemplate(alert, alertsData, context)
		} else if (isPeriodGroup(alert)) {
			context.title = i18n.get('alerts.title.' + _.camelCase(alert.type))
			context.detail = alertDomainPeriodsTemplate(context)
		} else {
			if (alertModel.isBroadcast()) {
				context.subTitle = _.get(alertsData.users[alert.userId], 'label')
				context.title = i18n.get('admin.alertPreferences.broadcastAlert')
				context.extraClass = 'broadcast-alert is-not-clickable'
			} else if (alertModel.isExportReady()) {
				context.title = i18n.get('common.export.alert.ready')
				context.message = i18n.get('common.export.alert.download', highlight(alertModel.get('label')))
			} else if (alertModel.isExportFailed()) {
				context.title = i18n.get('common.export.failed')
				context.message = alertModel.getExportFailedMessage()
			} else if (alertModel.isScheduledExport()) {
				let key = 'common.export.scheduledExport.ready'
				let args = [highlight(alertModel.get('label'))]
				if (!user.equals(alert.userId)) { // #28610
					key = 'common.export.scheduledExport.ready.from'
					const user = _.get(alertsData.users[alert.userId], 'label')
					args = [highlight(user), ...args]
				}
				context.message = i18n.get(key, ...args)
				setTitleFromDomainObject()
			} else if (alertModel.isPublished()) {
				setTitleFromDomainObject()
				context.subTitle = _.get(alertsData.users[alert.userId], 'label')
			} else if (alertModel.isMetricValueRequiresApproval()) {
				context.title = i18n.get('home.alerts.metricValueAlert')
			} else if (alertModel.isAccountChanged()) {
				context.title = i18n.get('alerts.email.title.single.account-changed')
			} else if (alertModel.isAccountDisabled()) {
				context.title = i18n.get('alerts.accountDisabledSoon')
				context.extraClass = 'is-not-clickable'
			} else if (alertModel.isFormAlert()) {
				context.subTitle = _.get(alertsData.users[alert.userId], 'label')
				context.title = i18n.get('alerts.form-alert')
			} else {
				setTitleFromDomainObject()
				if (_.startsWith(alert.type, 'comment-')) {
					context.comment = alert.comment ?
						'<q>' + _.trim(escapePreserveLineBreaks(alert.comment)) + '</q>' :
						_.escape(i18n.get('alerts.digests.commentDeleted'))
				}
			}
			const {icon, iconClass = 'icon'} = alertModel.getIcon(domainItem)
			context.icon = icon
			context.iconClass = iconClass
			this._decorateAlert(alertModel, context)
			context.detail = alertTemplate(context)
		}

		if (!_.isNil(domainId) && !domainItems?.[domainId]) {
			// #44928 Domain item is missing so don't show that the alert is clickable
			context.extraClass += ' is-not-clickable'
		}
		return context
	},

	_getMetricValuesReviewedTemplate: function (alert, alertsData, context) {
		const ownerId = _.get(alert, 'metricUpdates[0].ownerId')
		const ownerLabel = _.get(alertsData.users[ownerId], 'label')
		context.title = i18n.get('alerts.title.' + _.camelCase(alert.type), ownerLabel)
		const scorecardItems = _.get(alertsData, 'scorecard-item', [])

		// Removes changes that don't match the filter, and then removes
		// any empty period/org groups.
		const filterChanges = (predicate => {
			const copy = _.cloneDeep(alert.context)
			_.each(copy.periods, p => {
				_.each(p.orgs, o => {
					_.each(o.nodes, n => {
						_.remove(n.updates, predicate)
						// #50251 if the kpi has been deleted, make the kpi label appear not clickable
						let itemDeleted = _.isUndefined(scorecardItems[n.id])
						if (itemDeleted) {
							n.extraClass = 'is-not-clickable'
						}
						_.each(n.updates,  ({nodeId, changes}) => {
							this._formatMetricValueChanges(nodeId, changes)
							// #50251 if the kpi has been deleted, also make each item in the
							// change list appear not clickable
							if (itemDeleted) {
								_.each(changes, c => {
									c.extraClass = 'is-not-clickable'
								})
							}
						})
					})
					_.remove(o.nodes, n => _.isEmpty(n.updates))
				})
				_.remove(p.orgs, o => _.isEmpty(o.nodes))
			})
			_.remove(copy.periods, p => _.isEmpty(p.orgs))
			return copy
		})
		context.approved = filterChanges(c => c.status !== 'approved')
		context.rejected = filterChanges(c => c.status !== 'rejected')
		return alertMetricValuesReviewedTemplate(context)
	},
	_formatMetricValueChanges(nodeId, changes) {
		const sn = _.find(_.get(this.options.data, 'scorecard-item'), {id: nodeId})
		let format

		const isBlank = value => _.isNil(value) || (_.isString(value) && _.isEmpty(value))
		if (sn) {
			const {dataType, currencyCode, precision} = sn
			format = value => {
				let val = formatValue({value, dataType, currencyCode, precision})
				if (isBlank(val)) {
					val = i18n.get('common.blank')
				}
				return val
			}
		} else {
			// #41375 We don't have a reference to the scorecard (probably because
			// it was deleted) so just handle blank values
			format = value => {
				return isBlank(value) ? i18n.get('common.blank') : value
			}
		}
		_.each(changes, c => {
			c.old = format(c.old)
			c.new = format(c.new)
		})
	},

	onRead(e) { this.triggerChange(e, 'read') },
	onUnread(e) { this.triggerChange(e, 'unread') },
	onDelete(e) { this.triggerChange(e, 'delete') },
	triggerChange: function(event, action) {
		event.preventDefault()
		event.stopPropagation()
		this.covertButtonTooltips.removeTooltip()
		const item = this.$(event.target).closest('.alert-item')
		const {id} = item.data()
		this.trigger('change', {event, id, item, action})
	},

	goToAlert: function(e) {
		var li = this.$(e.target).closest('li')
		var details = li.find('.alert-clamp-container')
		var id = li.data('id')
		// Don't navigate on click for collapsed alert items, we want to expand them
		// if it's .toggle-collapse is clicked
		if (details.hasClass('needs-clamping') &&
			!details.hasClass('is-expanded')) {
			_.map(this.alertClamps, c => {
				if (c.id == id) {
					c.clamp.toggleExpanded(true)
				}
			})
			return
		}
		var alertItem = li.closest('.alert-item')
		var {id} = alertItem.data()
		const listItem = _.find(this.alertList, item => item.alert.id == id)
		var alert = new Alert(listItem.alert)

		$.post(`api/alerts/read/${id}`)

		if (conductor.isNavigationTarget(e)) {
			// if the user clicked on a sp-navigate link inside of the alert we
			// don't want to do anything further here.
			return
		}

		if (alert.isExportFailed()) {
			this._showFailedAlertDialog(alert)
		} else if (alert.isFileBased() && alert.hasFile()) { // No file, no action (23266)
			new Xhr().download({
				url: `api/alerts/${alert.get('id')}/file`
			})
		} else if (alert.isMetricValueRequiresApproval()) {
			// #39305 move to the metric approvals screen. Can't really use the
			// domain item logic below as this is a unique situation
			conductor.navigate('/home/metric-approvals', {trigger: true})
		} else if (alert.isMetricValuesReviewed()) {
			const dataNode = this.$(e.target).closest('[data-node-id]')
			if (!dataNode.length) return

			const {nodeId, periodId} = dataNode.data()
			// #44847 the scorecard item has been deleted so don't try
			// navigating to it
			if (!this.options.data['scorecard-item'][nodeId]) return

			this._navigateToUpdateForScorecard(alert, nodeId, periodId)
		} else if (alert.isAccountChanged()) {
			// #44421 navigate to the user that was modified
			conductor.navigate(`/admin/users/${alert.get('accountChangedId')}`, { trigger: true })
		} else if (!alert.isBroadcast()) {
			if (_.isUndefined(listItem.domainItem)) {
				return
			}
			let nodeId = listItem.domainItem.id
			if (alertItem.hasClass('node-id-req')) {
				nodeId = this.$(e.target).data('node-id')
			}
			if (!_.isUndefined(nodeId)) {
				this._navigateToAlert(li, listItem, nodeId)
			}
		}
	},

	_showFailedAlertDialog: function(alert) {
		const dialog = new ExportStatusDialog({ model: alert })
		appDisplay.dialog(dialog)
	},

	_navigateToAlert(li, listItem, nodeId) {
		const {periodId} = li.data()
		const {periodId: alertPeriodId, noteId, type: alertType} = listItem.alert
		// alerts with multiple domain objects listed have the period on the <li>
		// #33804
		let actualPeriod = periodId || alertPeriodId
		var url = `${sections.toUrl(listItem.section)}/${nodeId}`
		if (noteId) {
			url += `/note/${noteId}`
		}
		// #22079 send domainItem type to period change confirmation
		let itemType = _.get(listItem.domainItem, 'type')
		const domainLabel = _.escape(alertMetadata.getDomainLabel(alertType, itemType))
		periodChangeConfirmation({periodId: actualPeriod, domainLabel, url})
	},

	_navigateToUpdateForScorecard: function(alert, nodeId, periodId) {
		let url
		if (_.some(alert.get('metricUpdates'), {nodeId, isUpdaterAssigned: true})) {
			url = `home/metric-updates/${nodeId}/${periodId}`
		} else {
			url = `scorecards/${nodeId}`
		}
		const periodLabel = calendars.periodsById[periodId].label
		const domainLabel = this.options.data['scorecard-item'][nodeId].label
		const message = i18n.get('alerts.propertyChange.periodChangeConfirmation',
			highlight(periodLabel), highlight(domainLabel))
		periodChangeConfirmation({periodId, message, url})
	},

	/**
	 * There are business rules that apply based on the type and state of
	 * alerts, this function applies these rules after the raw data is pulled
	 * out of the alerts response
	 *
	 * @param {Alert} alert The alert object from the server
	 * @param context client attributes for the display of an alert
	 * @private
	 */
	_decorateAlert: function(alert, context) {

		const {type, action, label} = alert.attributes

		const setTitle = (context, key) => {
			context.title = i18n.get(`alerts.title.${key}`, context.title)
		}
		const actionToDecorators = (key, removedKey) => {
			return {
				'added': context => setTitle(context, key),
				'removed': context => setTitle(context, removedKey || key)
			}
		}
		const typeToActionDecorators = {
			'initiative-user-assigned': actionToDecorators('assigneeAdded', 'assigneeRemoved'),
			'updater-user-changed': actionToDecorators('updaterOf'),
			'updater-group-changed': actionToDecorators('updaterOf'),
			'owner-user-changed': actionToDecorators('ownerOf'),
			'owner-group-changed': actionToDecorators('ownerOf')
		}

		const actions = typeToActionDecorators[type]
		const actionDecorator = actions && actions[action]
		actionDecorator && actionDecorator(context)

		// Alerts that would download a file, where file no longer exists
		if (alert.hasDeletedFile()) {
			if (alert.isPublished()) {
				const subTitle = i18n.get('alerts.file.deleted', i18n.get('common.file'))
				context.subTitle = `(${subTitle})`
			} else if (alert.isExportReady()) {
				const msg = i18n.get('alerts.file.deleted', highlight(label))
				context.message = `(${msg})`
				context.extraClass = 'is-not-clickable'
			}
		}
	},

	_resolveTitle: function (alert, domainItem) {
		let title = _.result(domainItem, 'label')
		if (!title) {
			const id = formatValue({ value: alert.domainId, dataType: NUMBER, shorten: false})
			const {domainType} = alert
			if (domainType === 'initiative') {
				// Deleted Initiative alerts preserve the label
				const labelOrId = _.result(alert, 'label', id)
				title = i18n.get('alerts.deletedInitiative', labelOrId)
			} else if (id) {
				title = i18n.get(alertMetadata.deletedCodes[domainType], id)
			} else {
				title = _.defaultTo(alert.domainLabel, alert.label)
			}
		}
		return title
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.covertButtonTooltips], 'remove')
		$(window).off('resize', this.adjustOverflow)
	}
})

export default AlertList

AlertList.__filename__ = 'home/alerts/alert-list.js'
